import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit16Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 16';
        this.id = 'node_tibbit_16';
        this.linkedFeature = 'general';
        this.description = '3 PWMs with open collector outputs';
        this.inputs = [
            {
                name: 'Set',
                portId: 'pwm_set',
                params: [],
            },
        ];

        const settings: Array<Setting> = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_16',
                default: '',
            },
            {
                id: 'FREQUENCY',
                name: 'Frequency',
                settingType: SettingType.NUMBER,
                default: 1000,
                min: 500,
                max: 500000,
            },
            {
                id: 'CHANNEL',
                name: 'Channel',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Channel 1',
                        value: '1',
                    },
                    {
                        name: 'Channel 2',
                        value: '2',
                    },
                    {
                        name: 'Channel 3',
                        value: '3',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('TIBBIT'));
        if (!tibbit) {
            return blocks;
        }
        const TIBBIT_NAME = `${tibbit.getSettingValue('NAME')}`;
        const I2C_CHANNEL = `${TIBBIT_NAME}_CHANNEL`;
        const PWM_CHANNEL = this.getSettingValue('CHANNEL');

        const doneLinks = project.getNodeLinks(this, 'done');
        const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
        const links = project.getNodeLinks(this, 'pwm_set');
        for (let i = 0; i < links.length; i++) {
            const link = links[i];

            const frequency = this.getSettingValue('FREQUENCY');
            const duty_cycle = tibbit.getSettingValue(`L${PWM_CHANNEL}NAME`);
            let pulseWidth = 0;
            let period = 0;
            const prescaler = 64;
            period = (1000 + 1) * 4 * frequency * prescaler;
            pulseWidth = duty_cycle / 100 * period;

            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    tbt_pic_gra_pwm_config_simple(${TIBBIT_NAME}, PIC_PWM${PWM_CHANNEL - 1}, ${frequency}, ${duty_cycle})
    ${doneBlock}`,
            });
        }

        return blocks;
    }
}
